var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SvgIcon',{attrs:{"name":"icone_favoritos","fill":_vm.favorito.fill,"view-box":"0 0 50 48","height":"22","width":"auto"},on:{"mouseover":_vm.handleHoverFavoritos,"mouseleave":_vm.handleHoverFavoritos,"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }